import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const BriefcaseIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg style={style} className={className} viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.198 3.561h-2.4v-.807a2.41 2.41 0 0 0-2.4-2.42h-1.6a2.41 2.41 0 0 0-2.4 2.42v.807h-2.4a2.39 2.39 0 0 0-1.697.71 2.432 2.432 0 0 0-.703 1.711v7.264a2.41 2.41 0 0 0 2.4 2.42h11.2a2.41 2.41 0 0 0 2.4-2.42V5.982a2.41 2.41 0 0 0-2.4-2.42zm-7.2-.807c0-.445.358-.807.8-.807h1.6c.441 0 .8.362.8.807v.807h-3.2v-.807zm8 10.492a.804.804 0 0 1-.8.807h-11.2a.804.804 0 0 1-.8-.807V8.807c.78.312 1.582.566 2.4.759v.476c0 .445.358.807.8.807.441 0 .8-.362.8-.807v-.17c.795.11 1.597.166 2.4.17.802-.004 1.604-.06 2.4-.17v.17c0 .445.358.807.8.807.441 0 .8-.362.8-.807v-.476c.817-.193 1.62-.447 2.4-.759v4.439zm0-6.206c-.778.33-1.58.6-2.4.807v-.25a.804.804 0 0 0-.8-.808c-.442 0-.8.362-.8.807v.598a15.95 15.95 0 0 1-4.8 0v-.598a.804.804 0 0 0-.8-.807c-.442 0-.8.362-.8.807v.267a16.213 16.213 0 0 1-2.4-.807V5.982c0-.445.358-.807.8-.807h11.2c.441 0 .8.362.8.807V7.04z"
        fillRule="evenodd"
      />
    </svg>
  )
})
